"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IC3 = 'IC3';
var DirectLine = 'DirectLine';
var ACS = 'ACS';
exports.default = {
    IC3: IC3,
    DirectLine: DirectLine,
    ACS: ACS
};
//# sourceMappingURL=ChatAdapterProtocols.js.map